<template>
    <v-container>
        <v-card id="searchDiv2">
            <v-toolbar color="primary" dark>
                <v-toolbar-title style="padding-left: 10px">{{$t(formName)}}</v-toolbar-title>
            </v-toolbar>
            <slot name="searchForm">
                <v-form @keyup.enter.native="onSearch">
                    <v-layout wrap>
                        <v-flex style="padding:10px" v-for="item in inputSearchItems" :key="item.itemText" xs6>
                            <v-select :item-text="item.itemText"
                                      :item-value="item.itemValue"
                                      :items="item.items"
                                      :label="$t(item.label)"
                                      ref="input"
                                      v-if="item.type=='select'"
                                      v-model.trim="values[item.name]"
                            ></v-select>
                            <c-textbox :autofocus="item.focus"
                                       :icon="item.icon"
                                       :label="$t(item.label)"
                                       :placeholder="item.placeHolder"
                                       :type="item.type"
                                       v-else-if="item.type=='text'" v-model.trim="values[item.name]"></c-textbox>
                            <i-date-picker
                                    :label="$t(item.label)"
                                    formatter="DD/MM/YYYY"
                                    v-else-if="item.type=='datepicker'"
                                    v-model="values[item.name]">

                            </i-date-picker>

                        </v-flex>
                    </v-layout>
                </v-form>
                <div style="text-align: center;">
                    <v-btn @click="onSearch" color="primary" dark>
                        <v-icon dark left>search</v-icon>
                        {{$t('lang.common.search')}}
                    </v-btn>
                    <v-btn @click="createNew" color="red" dark v-if="acceptCreate == true">
                        <v-icon dark left>add</v-icon>
                        {{$t('lang.common.add')}}
                    </v-btn>
                    <slot name="feartureBtn">

                    </slot>
                </div>
            </slot>
            <slot name="tableData">
                <v-data-table :headers="fields" :items="items" :pagination.sync="pagination"
                              :rows-per-page-items="rowsPerPageItems"
                              :total-items="totalRows"
                              @update:pagination="onPaging"
                              id="resultTable"
                >
                    <template slot="headers">
                        <th :width="header.width" v-for="header in fields">
                            <div style="text-align: center" v-if="header.value=='checkbox'">
                                <v-checkbox color="primary" hide-details v-model="selectAll"></v-checkbox>
                            </div>
                            <div :style="header.headerStyle" v-else>
                                {{$t(header.text)}}
                            </div>
                        </th>
                    </template>
                    <template slot="items" slot-scope="data">
                        <td v-for="header in fields">
                            <div style="text-align: center" v-if="header.value=='index'">
                                {{pagination.rowsPerPage*(pagination.page-1)+ data.index+1}}
                            </div>
                            <div v-else-if="header.value=='checkbox'">
                                <v-checkbox color="primary" hide-details v-model="data.item['check']"></v-checkbox>
                            </div>
                            <div v-else-if="header.compound==undefined || header.compound ==false">
                                <div v-if="header.dateFormat != undefined">
                                    {{displayDate(data.item[header.value],header.dateFormat) }}
                                </div>
                                <div v-else-if="header.formatter != undefined && header.formatter != null" v-html="header.formatter(data.item[header.value])">
                                </div>
                                <div v-else>
                                    {{data.item[header.value]}}
                                </div>
                            </div>
                            <div style="text-align: center" v-else-if="header.value=='action'">
                                <v-btn @click="editItem(data)" color="primary" dark depressed fab icon outline small
                                       title="edit">
                                    <v-icon>edit</v-icon>
                                </v-btn>
                                <v-btn @click="deleteItem(data)" color="pink" dark depressed fab icon outline small
                                       title="delete"
                                       v-if="acceptDelete == true">
                                    <v-icon>delete</v-icon>
                                </v-btn>
                                <v-btn @click="copyItem(data)" color="deep-purple" dark depressed fab icon outline small
                                       title="copy"
                                       v-if="acceptCopy == true">
                                    <v-icon>file_copy</v-icon>
                                </v-btn>
                                <v-btn @click="viewPresent(data)" color="deep-purple" dark depressed fab icon outline small
                                       title="Xem danh sách đại diện"
                                       v-if="acceptViewPresent == true">
                                    <v-icon>view_headline</v-icon>
                                </v-btn>
                                <v-btn @click="viewDocument(data)" color="deep-purple" dark depressed fab icon outline small
                                       title="Xem danh sách Tài liệu"
                                       v-if="acceptViewDocument == true">
                                    <v-icon>view_headline</v-icon>
                                </v-btn>
                            </div>
                            <slot :item="data.item" :name="header.value" v-else></slot>
                        </td>
                    </template>
                </v-data-table>
            </slot>
        </v-card>
        <slot name="extra_component"/>
        <slot name="createForm">
            <div id="createDiv2" style="display: none">
                <c-create-form :create-form-name="createFormName" :create-url="createUrl" :default-data="selectedItem"
                               :input-items="inputCreateItems"   ref="createForm" @close="hideCreateForm"
                                v-if="inputCreateItems.length > 0"/>
            </div>

        </slot>
    </v-container>
</template>

<script>
    import CTextbox from "./Textbox";
    import CCreateForm from "./CreateForm";
    import IDatePicker from "./DatePicker";
    import axios from "axios";
    import VueController from "../../../public/js/controller";
    import {message} from "@/shared/message";
    import { router } from "../../router";

    export default {
        name: 'list-form2',
        components: {IDatePicker, CCreateForm, CTextbox},
        inheritAttrs: true,
        props: {
            formName: {
                type: String,
                default: 'Manager'
            },
            inputSearchItems: {
                type: Array,
                default: () => []
            },
            hiddenSearchItems: {
                type: Object,
                default: () => []
            },
            inputCreateItems: {
                type: Array,
                default: () => []
            },
            searchUrl: {
                type: String,
                default: ""
            },
            createUrl: {
                type: String,
                default: ""
            },
            deleteUrl: {
                type: String,
                default: ""
            },
            fields: {
                type: [Array, Object],
                default: () => []
            },
            rowsPerPageItems: {
                type: [Array, Number],
                default: () => [10, 5, 20, 30, 40, 50]
            },
            pageSize: {
                type: Number,
                default: 10
            },

            acceptCreate: {
                type: Boolean,
                default: true
            },
            acceptDelete: {
                type: Boolean,
                default: true
            },
            acceptCopy: {
                type: Boolean,
                default: false
            },
            acceptViewPresent: {
                type: Boolean,
                default: false
            },

            acceptViewDocument: {
                type: Boolean,
                default: false
            },
            keyProperty: {
                type: String,
                default: ""
            },
            createFormName: {
                type: String,
                default: ""
            },
            customerId: {
                type: Number,
                default: -1,
            },

        },
        data: () => {
            return {
                values: {},
                items: [],
                model: {},
                pagination: {
                    rowsPerPage: 20,
                    page: 1,
                    totalItems: 0
                },
                selectedItem: {},
                currentPage: 1,
                totalRows: 0,
                selectAll: false
            }
        },
        created() {
            VueController.push(this);
            for(let i=0;i<this.inputSearchItems.length;i++){
                if(this.inputSearchItems[i].value != undefined && this.inputSearchItems[i].value != null) {
                    this.values[this.inputSearchItems[i].name] = this.inputSearchItems[i].value;
                }
            }
            // for(let i=0;i<this.hiddenSearchItems.length;i++){
            //     if(this.hiddenSearchItems[i].value != undefined && this.hiddenSearchItems[i].value != null) {
            //         this.values[this.hiddenSearchItems[i].name] = this.hiddenSearchItems[i].value;
            //     }
            // }

            if(this.hiddenSearchItems.value != undefined && this.hiddenSearchItems.value != null) {
                this.values[this.hiddenSearchItems.name] = this.hiddenSearchItems.value;
            }


            this.search();
        },
        destroyed() {
            VueController.removeComponentByEl(this);
        },

        computed: {
            lstModel: function () {
                return FormGenerator.lstModel;
            }
        },

        watch: {
            selectAll: function (value) {
                for (let i = 0; i < this.items.length; i++) {
                    this.items[i]["check"] = value;
                }
            },
            customerId: function (value) {
                if(this.customerId != undefined && this.customerId != null) {
                    this.values['customerId'] = value;
                    console.log("values", this.values);
                    this.search();
                }
            },
        },

        methods: {
            onSearch: function () {
                //this.currentPage = 1;
                this.pagination.page = 1;
                this.search();
            },

            displayDate: function (data, format) {
                console.log(data);
                let dateDate = new Date(data);
                let month = dateDate.getMonth() + 1;
                if (month < 10) {
                    month = "0" + month;
                }
                let year = dateDate.getFullYear();
                let date = dateDate.getDate();
                if (date < 10) {
                    date = "0" + date;
                }
                let second = dateDate.getSeconds();
                let minute = dateDate.getMinutes();
                let hour = dateDate.getHours();
                let dateStr = format.replace("dd", date).replace("MM", month).replace("yyyy", year).replace("mm", minute).replace("hh", hour).replace("ss", second);
                return dateStr;
            },

            search: function () {
                //let header = {headers:new authHeader()};
                //console.log(header);
                this.selectAll = false;
                let connect = "?";
                if (this.searchUrl.charAt(this.searchUrl.length - 1) == "&") {
                    connect = "";
                }
                axios.post(process.env.VUE_APP_API_URL + this.searchUrl + connect + "pageSize=" + this.pagination.rowsPerPage + "&page=" + this.pagination.page, this.values).then((data) => {
                    console.log("-after post get data");
                    console.log(data);
                    this.items = data.items;
                    this.totalRows = data.count;
                    this.$emit("search");
                });
            },

            onPaging: function (page) {
                this.pagination = page;
                this.currentPage = page.page;
                this.search();
            },

            isEmpty: function (obj) {
                for (var key in obj) {
                    if (obj.hasOwnProperty(key))
                        return false;
                }
                return true;
            },

            createNew: function () {
                this.showCreateForm({});
            },

            editItem: function (data) {
                console.log(data.item);
                this.showCreateForm(data.item);
            },

            copyItem: function (data) {
                //console.log(data.item);
                data.item[this.keyProperty] = "";
                this.showCreateForm(data.item);
            },

            viewPresent: function(data) {

                this.$emit("viewPresent", data.item);
                // let id = data.item[this.keyProperty]
                // this.$router.push('/viewPresent/' + id);
            },

            viewDocument: function(data) {
                this.$emit("viewDocument", data.item);
                // let id = data.item[this.keyProperty]
                // this.$router.push('/viewDocument/' + id);
            },


            showCreateForm: function (item) {
                document.getElementById("searchDiv2").style.display = "none";
                document.getElementById("createDiv2").style.display = "";
                this.selectedItem = item;

                //linhdx them các thuộc tinh hidden vào form tạo mới
                for(let i=0;i<this.hiddenSearchItems.length;i++){
                    if(this.hiddenSearchItems[i].value != undefined && this.hiddenSearchItems[i].value != null) {
                        this.selectedItem[this.hiddenSearchItems[i].name] = this.hiddenSearchItems[i].value;
                    }
                }

                if(this.customerId != undefined && this.customerId != null) {
                    this.selectedItem['customerId'] = this.customerId;
                }

                console.log("this.selectedItem", this.selectedItem);
                console.log("this.$slots.createForm", this.$slots.createForm);

                if (!this.isEmpty(this.$slots)) {
                    if (this.$slots.createForm != undefined) {
                        let child = this.$slots.createForm[0].componentInstance;
                        child.onView(this.selectedItem);
                    }
                }
            },

            hideCreateForm: function(){
                try {
                    if (document.getElementById("searchDiv2") != null)
                        document.getElementById("searchDiv2").style.display = "";
                    if (document.getElementById("createDiv2") != null)
                        document.getElementById("createDiv2").style.display = "none";

                    this.onSearch();
                } catch (e) {
                    console.log(e);
                }
            },

            deleteItem: function (data) {
                if (confirm(this.$t("lang.common.deleteConfirm"))) {
                    //let header = {headers:new authHeader()};
                    axios.post(process.env.VUE_APP_API_URL + this.deleteUrl, data.item).then(data => {
                        message.success(this.$t("lang.common.delete_success"));
                        this.search();
                    }, error => {
                        message.error(this.$t("lang.common.deleteError"));
                    });
                }
                ;
            }

        }

    }
</script>
